import { render, staticRenderFns } from "./Ratificantes.vue?vue&type=template&id=0e5a23f0&scoped=true"
import script from "./Ratificantes.vue?vue&type=script&lang=js"
export * from "./Ratificantes.vue?vue&type=script&lang=js"
import style0 from "./Ratificantes.vue?vue&type=style&index=0&id=0e5a23f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5a23f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e5a23f0')) {
      api.createRecord('0e5a23f0', component.options)
    } else {
      api.reload('0e5a23f0', component.options)
    }
    module.hot.accept("./Ratificantes.vue?vue&type=template&id=0e5a23f0&scoped=true", function () {
      api.rerender('0e5a23f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/infoBase/Ratificantes.vue"
export default component.exports